import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import _get from 'lodash-es/get';
import { Store } from '@shared/core/utils';
import { Person } from '@crm/shared/persons/types';
import { EntityId } from '@shared/core/types';
import { PersonPageSharedService, PersonApiSharedService } from '@crm/shared/persons';

class Actions {
  loadPerson: Subject<void>;
}

const initialState = {
  person: null as Person,
};

@Injectable({
  providedIn: 'root',
})
export class PersonPageService {
  private store = new Store<typeof initialState>(initialState);
  private store$ = this.store.asReadonly();
  private actions: Actions = {
    loadPerson: new Subject<void>(),
  };

  constructor(private personApi: PersonApiSharedService, private sharedPersonPage: PersonPageSharedService) {
    this.initLoadPerson();
    this.sharedPersonPage.setPerson(this.getPerson());
  }

  /**
   * SSOT
   */
  getPersonId(): EntityId {
    return Number(_get(this.store$.get('person'), 'id', 0));
  }

  getPerson(): Observable<Person> {
    return this.store$.select('person');
  }

  loadPerson(id: EntityId): Observable<Person> {
    return this.personApi.getPerson(id, 'person-page').pipe(
      tap(person =>
        this.store.update(state => ({
          ...state,
          person,
        })),
      ),
      tap(() => this.sharedPersonPage.setPersonId(this.getPersonId())),
    );
  }

  refreshPerson(): void {
    this.actions.loadPerson.next();
  }

  private initLoadPerson(): void {
    this.actions.loadPerson
      .asObservable()
      .pipe(switchMap(() => this.loadPerson(this.getPersonId())))
      .subscribe();
  }
}
